export const courtageDataFields = `
  courtageData {
    courtage
    courtageInPercent
    plusVAT
    text
  }
  `;
